import {observer} from 'mobx-react';
import React, {useCallback, useEffect} from 'react';
import {Table, Modal, ConfirmPopMessage, Label} from '@vidazoo/ui-kit';
import {useNotificationSettingsListContext} from '../context/SettingsListContext';
import {SettingsTableHeader} from './SettingsTableHeader';
import SettingsTableRow from './SettingsTableRow';
import theme from '../view/theme.module.scss';

export default observer(function SettingsList() {
    const {model} = useNotificationSettingsListContext();
    useEffect(() => {model.resetFilter(); model.fetch();}, [model]);
    const renderRow = useCallback((itemIndex, viewportIndex, style) =>
        <SettingsTableRow key={model.maskItems[itemIndex]?._id || itemIndex} itemIndex={itemIndex} style={style}/>, [model]);
    const renderHeader = useCallback(() => <SettingsTableHeader/>, []);
    if (model.items.isLoading) return <div className={theme.message} role="status">Loading Notifications Settings<br/>Please wait...</div>;
    if (model.items.error) return <div className={theme.message} role="alert">Failed to load Notifications Settings<br/>We had an error loading the requested page. <button type="button" onClick={() => model.fetch()}>Retry</button></div>;
    return <>
        {model.actionError && <div className={theme.error} role="alert">{model.actionError}</div>}
        <Table className={theme.table} viewportHeight="80vh" itemsCount={model.maskItems.length} rowHeight={40}
            renderRow={renderRow} renderHeader={renderHeader} columnsManager={model} overscanItems={5} useStickyScrollbar/>
        <Modal external exitOnClickOutside isOpen={!!model.promptDeleteItem} onClose={() => {model.promptDeleteItem = null;}}>
            <ConfirmPopMessage red title="Delete Notification Setting"
                text={<span>Are you sure you want to delete <Label weight={600} block={false}>{model.promptDeleteItem?.name || ''}</Label>?</span>}
                cancelText="No, Cancel" confirmText="Yes, Delete"
                onCancelClick={() => {model.promptDeleteItem = null;}} onConfirmClick={model.deleteItem}/>
        </Modal>
    </>;
});
